export default __webpack_public_path__ + "static/SRUS SB245 - Especification Del Producto y Datos Técnicos-14ad79a3933de8cd37951d5f5658e97d.pdf";